/* Secondelle - page produit : offres 1 / 2+1 / 3+2 avec choix teinte + taille par paire,
   guide des tailles en fenetre, ajout au panier de toutes les paires en une fois.
   Livraison : offerte avec l'offre 3 + 2 (5 paires), sinon le tarif lu dans data-ship (snippet secondelle-bundles).
   Si quelque chose manque (pas de formulaire produit), la page garde le comportement normal du theme. */
(function () {
  'use strict';
  if (window.__sdPdp) return;
  window.__sdPdp = true;

  var DOTS = { 'Nude': '#E3C3A0', 'Miel': '#C99A6B', 'Caramel': '#A86A3C', 'Café': '#6F4A33', 'Marron': '#4A2F22', 'Ébène': '#231A17' };
  var SHIP = 799;
  var state = { qty: 1, pairs: [] };
  var box, variants = [], shades = [], sizes = [], unit = 0;

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function findVariant(o1, o2) {
    for (var i = 0; i < variants.length; i++) if (variants[i].o1 === o1 && variants[i].o2 === o2) return variants[i];
    return null;
  }
  function firstAvailableShade(o2) {
    for (var i = 0; i < shades.length; i++) { var v = findVariant(shades[i], o2); if (v && v.a) return shades[i]; }
    return shades[0];
  }
  function paidFor(q) { return q === 5 ? 3 : q === 3 ? 2 : q; }

  function select(name, values, current, label) {
    var s = document.createElement('select');
    s.className = 'sd-pair__select';
    s.setAttribute('data-sd-field', name);
    s.setAttribute('aria-label', label);
    values.forEach(function (v) {
      var o = document.createElement('option');
      o.value = v; o.textContent = v;
      if (v === current) o.selected = true;
      s.appendChild(o);
    });
    return s;
  }

  function renderPairs() {
    var cards = box.querySelectorAll('.sd-offer');
    for (var c = 0; c < cards.length; c++) {
      var wrap = cards[c].querySelector('[data-sd-pairs]');
      var q = parseInt(cards[c].getAttribute('data-qty'), 10);
      if (q !== state.qty) { wrap.hidden = true; wrap.innerHTML = ''; continue; }
      wrap.innerHTML = '';
      wrap.hidden = false;
      var paid = paidFor(q);
      for (var i = 0; i < q; i++) {
        var p = state.pairs[i];
        var row = document.createElement('div');
        row.className = 'sd-pair';
        row.setAttribute('data-index', i);
        var lab = document.createElement('span');
        lab.className = 'sd-pair__label';
        lab.innerHTML = 'Paire ' + (i + 1) + (i >= paid ? ' <em>offerte</em>' : '');
        var dot = document.createElement('span');
        dot.className = 'sd-pair__dot';
        dot.style.background = DOTS[p.o1] || '#ccc';
        var shadeWrap = document.createElement('span');
        shadeWrap.className = 'sd-pair__field';
        shadeWrap.appendChild(dot);
        shadeWrap.appendChild(select('o1', shades, p.o1, 'Teinte de la paire ' + (i + 1)));
        var sizeWrap = document.createElement('span');
        sizeWrap.className = 'sd-pair__field sd-pair__field--size';
        sizeWrap.appendChild(select('o2', sizes, p.o2, 'Taille de la paire ' + (i + 1)));
        row.appendChild(lab);
        row.appendChild(shadeWrap);
        row.appendChild(sizeWrap);
        wrap.appendChild(row);
      }
    }
    updateTotal();
  }

  function updateTotal() {
    var el = box.querySelector('[data-sd-total]');
    if (!el) return;
    var paid = paidFor(state.qty);
    var free = state.qty - paid;
    var txt = 'Total : <strong>' + money(unit * paid) + '</strong>';
    if (free) txt += ' pour ' + state.qty + ' paires · <span>' + free + ' offerte' + (free > 1 ? 's' : '') + '</span>';
    if (state.qty >= 5) txt += ' · <span>livraison offerte</span>';
    else txt += ' · livraison ' + money(SHIP) + ' <small>(offerte avec 3 + 2)</small>';
    var bad = state.pairs.slice(0, state.qty).some(function (p) { var v = findVariant(p.o1, p.o2); return !v || !v.a; });
    if (bad) txt = 'Une des combinaisons teinte + taille choisies est indisponible. Modifiez-la pour continuer.';
    el.innerHTML = txt;
    el.classList.toggle('is-error', bad);
  }

  function setQty(q) {
    var last = state.pairs[state.pairs.length - 1];
    while (state.pairs.length < q) state.pairs.push({ o1: last.o1, o2: last.o2 });
    state.qty = q;
    renderPairs();
  }

  /* ---------- Ajout au panier ---------- */
  function lines() {
    var map = {}, order = [];
    for (var i = 0; i < state.qty; i++) {
      var v = findVariant(state.pairs[i].o1, state.pairs[i].o2);
      if (!v || !v.a) return null;
      if (!map[v.id]) { map[v.id] = 0; order.push(v.id); }
      map[v.id]++;
    }
    return order.map(function (id) { return { id: id, quantity: map[id] }; });
  }

  function addToCart(form) {
    var items = lines();
    if (!items) { updateTotal(); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    var host = form.closest('product-form-component') || form;
    var btn = form.querySelector('[ref="addToCartButton"], button[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    var sections = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) { if (el.dataset.sectionId) sections.push(el.dataset.sectionId); });
    var root = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';

    import('@shopify/events').then(function (mod) {
      var Ev = mod.CartLinesUpdateEvent;
      var deferred = Ev.createPromise();
      host.dispatchEvent(new Ev({
        action: 'add', context: 'product',
        lines: items.map(function (it) { return { merchandiseId: String(it.id), quantity: it.quantity }; }),
        promise: deferred.promise
      }));
      return fetch(root, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: sections.join(',') })
      }).then(function (r) { return r.json(); }).then(function (res) {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          deferred.resolve({
            cart: Ev.createCartFromAjaxResponse(cart),
            detail: { items: cart.items, source: 'secondelle-bundles', sourceId: 'sd-bundles', itemCount: state.qty, sections: res.sections, didError: !!res.status }
          });
          if (res.status) alert(res.description || res.message || 'Ajout impossible, réessayez.');
        });
      });
    }).catch(function () {
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function () { window.location.href = '/cart'; });
    }).finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }

  /* ---------- Guide des tailles ---------- */
  function openGuide() {
    var dlg = document.querySelector('[data-sd-guide]');
    if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); return true; }
    return false;
  }

  function init() {
    box = document.querySelector('[data-sd-bundles]');
    var data = document.querySelector('[data-sd-variants]');
    if (!box || !data) return false;
    try { variants = JSON.parse(data.textContent); } catch (e) { return false; }
    unit = parseInt(box.getAttribute('data-unit'), 10) || 0;
    SHIP = parseInt(box.getAttribute('data-ship'), 10) || SHIP;
    shades = (box.getAttribute('data-shades') || '').split('|').filter(Boolean);
    sizes = (box.getAttribute('data-sizes') || '').split('|').filter(Boolean);
    var start = { o1: box.getAttribute('data-o1'), o2: box.getAttribute('data-o2') };
    var mSize = sizes.indexOf('M') > -1 ? 'M' : start.o2;
    var mV = findVariant(start.o1, mSize);
    if (mV && mV.a) start.o2 = mSize;
    var sv = findVariant(start.o1, start.o2);
    if (!sv || !sv.a) start.o1 = firstAvailableShade(start.o2);
    state.pairs = [start];
    var checked = box.querySelector('input[name="sd-bundle"]:checked');
    document.documentElement.classList.add('sd-bundles-on');
    setQty(checked ? parseInt(checked.value, 10) : 1);

    box.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'sd-bundle') { setQty(parseInt(t.value, 10) || 1); return; }
      var field = t.getAttribute && t.getAttribute('data-sd-field');
      if (field) {
        var row = t.closest('.sd-pair');
        var i = parseInt(row.getAttribute('data-index'), 10);
        state.pairs[i][field] = t.value;
        if (field === 'o1') { var d = row.querySelector('.sd-pair__dot'); if (d) d.style.background = DOTS[t.value] || '#ccc'; }
        updateTotal();
      }
    });
    return true;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!box || !form || !form.closest || !form.closest('product-form-component')) return;
    if (!document.documentElement.classList.contains('sd-bundles-on')) return;
    if (form.closest('.quick-add-modal, product-card')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addToCart(form);
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-sd-open="guide"]')) { if (openGuide()) e.preventDefault(); return; }
    var dlg = t.closest('[data-sd-guide]');
    if (dlg && (t === dlg || t.closest('[data-sd-close]'))) dlg.close();
  });

  function boot() {
    var tries = 0;
    (function tick() { if (init() || ++tries > 40) return; setTimeout(tick, 150); })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();